<template>
    <main>
        <Background
                :image="backgroundImage"
                :mobileImage="mobileImage"
                mobileHeight="80vh"
                :setBackgroundImage="setBackgroundImage"/>

        <Title
                title="Naredi<br>backup!"
                :extraBig="true"
                background="rgba(173, 223, 222, 0.7)"
                v-observe-visibility="observeTitle"/>

        <Floater :isVisible="showFloater"/>

        <Facts/>

        <Risk background="rgba(0, 0, 0, 0.8)">
            <p>Zaradi pokvarjenega diska ali ukradenega telefona lahko v trenutku ostaneš brez vseh dokumentov, slik,
                kontaktov.</p>

            <p class="highlight text-yellow">Edini način, da se uspešno zaščitiš pred izgubo podatkov, je varnostno
                kopiranje oz. backup!</p>

            <p>Še posebej je pomembno, da si narediš kopijo dokumentov s prenosnega oz. namiznega računalnika, saj je ta
                bolj izpostavljen okužbi z izsiljevalskimi virusi, ki zaklenejo vse dokumente in zahtevajo odkupnino v
                kriptovaluti.</p>
        </Risk>

        <Actions background="rgba(173, 223, 222, 0.7)"/>

        <Footer
                title="Naredi backup!"
                background="rgba(202, 231, 230, 1.0)"
                :gif="[ { src: require('../assets/naredi-backup.mp4'), type: 'video/mp4' }, { src: require('../assets/naredi-backup.webm'), type: 'video/webm' } ]"/>
    </main>
</template>

<script>
	// @ is an alias to /src
	import Title from '@/components/Title.vue'
	import Background from "../components/Background";

	export default {
		name: 'home',
		components: {
			Background,
			Title,
			Facts: () => import('@/components/first-rule-sections/Facts.vue'),
			Risk: () => import('@/components/Risk.vue'),
			Actions: () => import('@/components/first-rule-sections/Actions.vue'),
			Footer: () => import("@/components/Footer.vue"),
			Floater: () => import("@/components/Floater"),
		},
        props: {
			cookiesAccepted: {
				type: Boolean,
                default: false,
            },
        },
		data() {
			return {
				showFloater: false,
				backgroundImage: require("../assets/prvo-pravilo.jpg"),
				mobileImage: require("../assets/prvo-pravilo-mobile.jpg"),
				setBackgroundImage: false,
			}
		},
		methods: {
			observeTitle(isVisible) {
				this.showFloater = !isVisible;
			},
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.setBackgroundImage = true;
			});
		},
		watch: {
			cookiesAccepted: function () {
				this.$emit('updateHead');
			},
		},
		head: {
			script: function () {
				if (this.cookiesAccepted) {
					return [
						{
							type: 'text/javascript',
							src: 'https://www.googletagmanager.com/gtag/js?id=UA-102056350-5',
							async: true,
							body: false,
						},
						{
							type: 'text/javascript',
							i: `
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-102056350-5');
                                `,
						},
					]
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
</style>